import request from '@/router/axios'

export const getListByTeam = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/attendanceteamsum/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const workerSumExcelByTeam = params => request({
  url: '/api/mcc-worker/attendanceteamsum/workerTeamSumExcel',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})

export default {
  getListByTeam,
}
